import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Container, Row, Spinner } from 'reactstrap'
import Navbar from "../../components/Navbar"
import "./styles.css"
import { useNavigate } from 'react-router-dom'
import { SectorsTr, SectorsEn } from "../../redux/types"
import JobGroup from './JobGroup'
import { IJob } from '../../redux/types'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { getAllJobs } from '../../redux/slices/jobSlice'
import { convertSectorName } from "../../utils/convertSectorName"
import { useTranslation } from 'react-i18next'
import FilterModal from './FilterModal'
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export default function Jobs() {

    const { i18n, t } = useTranslation()

    const dispatch = useAppDispatch()
    const jobsTr: IJob[] = useAppSelector(state => state.job.allJobsTr)
    const jobsEn: IJob[] = useAppSelector(state => state.job.allJobsEn)
    const [jobs, setJobs] = useState<IJob[]>()


    const [notFound, setNotFound] = useState(false)

    const [sectorsTr, _] = useState<string[]>(Object.values(SectorsTr))
    const [sectorsEn, __] = useState<string[]>(Object.values(SectorsEn))
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [filterOptions, setFilterOptions] = useState({ sector: "" })

    useEffect(() => {
        dispatch(getAllJobs())
    }, [])

    useEffect(() => {
        dispatch(getAllJobs())
    }, [i18n.language])

    useEffect(() => {

        if (jobsEn && jobsTr && (jobsEn.length > 0 || jobsTr.length > 0)) {
            if (i18n.language === "en") setJobs(jobsEn)
            else if (i18n.language === "tr") setJobs(jobsTr)
            else setNotFound(true)
        }
    }, [jobsEn, jobsTr])

    const handleSetFilterOptions = (opts: any) => {
        setFilterOptions(opts)
    }

    const resetFilterOptions = () => setFilterOptions({ sector: "" })

    useEffect(() => {
        console.log(filterOptions)
        if (!filterOptions || !filterOptions?.sector || filterOptions?.sector === '') {
            setNotFound(false); // Hiçbir filtreleme yapılmazsa notFound true olmalı
            return;
        } else {
            if (jobs) {
                const found = jobs.some((job) => {
                    const sectorName = convertSectorName(job.sector, i18n.language);
                    return sectorName === filterOptions?.sector; // filterOptions.sector ile eşleşiyor mu?
                });
                setNotFound(!found);
            }

        }

    }, [filterOptions?.sector]);


    // useEffect(() => {

    //     if (filterOptions && filterOptions.sector !== '') {
    //         let count = 0
    //         let relevantJobs: IJob[] = []
    //         sectorsTr.map((sector, index) => {
    //             relevantJobs = jobs.filter((job) => convertSectorName(job.sector, i18n.language) === sector)
    //             if (relevantJobs.length > 0) {
    //                 count = relevantJobs.length
    //                 alert(relevantJobs.length)
    //             }
    //         })
    //         console.log(relevantJobs)
    //         if (count > 0) setNotFound(false)
    //         else setNotFound(true)
    //     }
    //     else {
    //         setNotFound(true)
    //     }
    // }, [filterOptions.sector])

    useEffect(() => {
        console.log(notFound)
    }, [notFound])

    return (
        <Container className='jobs'>
            <Navbar />
            <FilterModal isOpen={isFilterOpen} filterOptions={filterOptions} handleClose={() => setIsFilterOpen(false)} setFilterOptions={setFilterOptions} resetFilterOptions={resetFilterOptions} />
            <Row className='row-area'>
                <div className='mb-3' style={{ display: "flex", justifyContent: "end" }}>
                    <Button className='ms-3 custom-btn hover' color='info' size='lg' style={{ padding: "10px 20px 10px 20px" }} onClick={() => setIsFilterOpen(true)}>{i18n.language === "tr" ? "Filtrele" : "Filter"}<FilterAltIcon /></Button>
                </div>
                {!jobs ? <div style={{ height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spinner color='info' />
                </div> : (i18n.language === "tr" ? (sectorsTr.map((sector, index) => {

                    const relevantJobs = jobs.filter((job) => convertSectorName(job.sector, i18n.language) === sector)
                    let filteredJobs: any
                    if (filterOptions?.sector !== '') {
                        if (filterOptions && filterOptions.sector === sector)
                            filteredJobs = relevantJobs
                        else filteredJobs = undefined
                    }
                    else {
                        filteredJobs = relevantJobs
                    }
                    if (filteredJobs) {

                        return (
                            <JobGroup sector={sector} i18n={i18n} jobs={filteredJobs} key={index} />
                        )
                    }


                })) : (
                    (sectorsEn.map((sector, index) => {

                        const relevantJobs = jobs.filter((job) => convertSectorName(job.sector, i18n.language) === sector)
                        let filteredJobs: any
                        if (filterOptions?.sector !== '') {
                            if (filterOptions && filterOptions.sector === sector)
                                filteredJobs = relevantJobs
                            else filteredJobs = undefined
                        }
                        else {
                            filteredJobs = relevantJobs
                        }
                        if (filteredJobs) {

                            return (
                                <JobGroup sector={sector} i18n={i18n} jobs={filteredJobs} key={index} />
                            )
                        }

                    }))
                ))}
                {notFound && (<h4 style={{ color: "#fff" }}>
                    {/*@ts-ignore*/}
                    {t('notFound')}</h4>)}
            </Row>
        </Container>
    )
}
